<template>
  <component :is="embedded ? 'div' : 'v-main'">
    <component :is="embedded ? 'div' : 'v-container'" v-bind="embedded ? {} : { fluid: true }">
      <component :is="embedded ? 'div' : 'v-card'" v-bind="embedded ? {} : { elevation: 6, rounded: 'xxl' }" :class="embedded ? '' : 'app-card'">
        <v-card-title class="mt-4" v-if="!embedded">
          <v-btn class="mx-2" fab x-small color="primary" @click="$router.back()">
            <v-icon dark>mdi-arrow-left</v-icon> </v-btn
          >Add Categories
        </v-card-title>
        <component :is="embedded ? 'div' : 'v-card-text'">
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.name"
                @input="form.name = form.name.toUpperCase()"
              >
                <template v-slot:label>Category Name <span style="color:#f44336;font-weight:bold;">*</span></template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn text class="mr-2" @click="embedded ? $emit('close') : $router.back()">Cancel</v-btn>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save category
          </v-btn>
        </component>
      </component>
    </component>
  </component>
</template>
<script>
import axios from "axios";
export default {
  name: "CategoryCreatePage",
  props: {
    embedded: { type: Boolean, default: false },
  },
  data() {
    return {
      form: {
        name: "",
        parent_id: null,
      },
      isLoading: false,
    };
  },
  computed: {
    errors() {
      return this.$store.getters["errors/getErrors"] || {};
    },
  },
  mounted() {
    this.$store.dispatch("errors/setErrors", {});
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        this.$store.dispatch("errors/setErrors", {});
        let notifications = await axios.post("/categories", this.form);
        this.notifications = notifications.data.data;

        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        if (this.embedded) {
          this.$emit("saved");
          this.$emit("close");
        } else {
          this.$router.push("/categories");
        }
      } catch (e) {
        console.log(e);
        this.isLoading = false;
        if (e.response && e.response.data && e.response.data.errors) {
          this.$store.dispatch("errors/setErrors", e.response.data.errors);
        }
      }
    },
  },
};
</script>
